// extracted by mini-css-extract-plugin
module.exports = {"templates":"WhatsappTemplatesList_templates__2P5C6","templatesAnim":"WhatsappTemplatesList_templatesAnim__2NwKH"};